import { render, staticRenderFns } from "./riskPatrol.vue?vue&type=template&id=15825a10"
import script from "./riskPatrol.vue?vue&type=script&lang=js"
export * from "./riskPatrol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15825a10')) {
      api.createRecord('15825a10', component.options)
    } else {
      api.reload('15825a10', component.options)
    }
    module.hot.accept("./riskPatrol.vue?vue&type=template&id=15825a10", function () {
      api.rerender('15825a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskPatrol.vue"
export default component.exports